module.exports = __webpack_public_path__ + "static/paris-004.thumb-7f243583d71ac079479dc368784060c8.jpg";